import getConfig from 'next/config'

import { ArrowRightIcon } from '@nx/fire/assets'
import { Body } from '@nx/fire/typography'
import { getTranslate } from '@nx/translations'
import { useUserInteraction } from '@nx/utils/google-tag-manager'

import {
  StyledCTALabel,
  StyledFireCard,
  StyledFireImage,
  StyledFireLink,
  StyledHeading,
  StyledLabel,
  StyledSeparator,
} from './SellingPromoCard.style'
import translate from './SellingPromoCard.translate.json'

const { publicRuntimeConfig } = getConfig()

const { text } = getTranslate(translate)

export const SellingPromoCard = ({
  sellingPromoCardTracking,
}: ThinkingOfSellingPromoCardProps) => {
  const { recordInteraction } = useUserInteraction()

  return (
    <div>
      <StyledFireCard
        Image={
          <StyledFireImage
            src="/web-assets/sell-hub-promo.jpg"
            alt={text('sellHubPromo.category')}
            width="200"
            height="200"
          />
        }
        settings={{
          imagePadding: false,
        }}
      >
        <StyledLabel $level="S">{text('sellHubPromo.category')}</StyledLabel>
        <StyledFireLink
          href={publicRuntimeConfig.SELL_HUB_BASE_URL}
          onClick={() => {
            if (sellingPromoCardTracking) {
              recordInteraction({
                ...sellingPromoCardTracking,
                action: 'sell-hub-card.click',
                label: '',
              })
            }
          }}
        >
          <StyledHeading $level={5} as="h5">
            {text('sellHubPromo.title')}
          </StyledHeading>
        </StyledFireLink>
        <Body>{text('sellHubPromo.description')}</Body>
        <StyledCTALabel aria-hidden="true">
          {text('sellHubPromo.cta')} <ArrowRightIcon width="25" height="25" />
        </StyledCTALabel>
      </StyledFireCard>
      <StyledSeparator />
    </div>
  )
}

type ThinkingOfSellingPromoCardProps = {
  sellingPromoCardTracking?: { category: string }
}
